import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChemicalElement, ElementValue } from '../models';

export const elementActions = createActionGroup({
    source: 'Element',
    events: {
        'Get Element': props<{ id: string }>(),
        'Get Element Success': props<{ payload: ChemicalElement }>(),
        'Get Element Error': props<{ code: number }>(),

        'Create Element': props<{ value: ElementValue }>(),
        'Create Element Success': props<{ payload: ChemicalElement }>(),
        'Create Element Error': props<{ code: number }>(),

        'Update Element': props<{ id: string; value: ElementValue }>(),
        'Update Element Success': props<{ payload: ChemicalElement }>(),
        'Update Element Error': props<{ code: number }>(),

        'Delete Element': props<{ id: string }>(),
        'Delete Element Success': props<{ id: string }>(),
        'Delete Element Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
